import { Star } from '../icons/WhatsAppIcon';

// Einheitlicher Seitenkopf für Text-/Unterseiten (Impressum, Datenschutz, Bildquellen, Smartcases …)
export const PageIntro = ({ eyebrow, title, intro, children, tone = 'off', testId }) => {
  const dark = tone === 'purple' || tone === 'deep';
  return (
    <section className={`sec--tight border-b-2 border-ink ${tone === 'purple' ? 'sec--purple' : tone === 'deep' ? 'sec--deep' : tone === 'lilac' ? 'sec--lilac' : 'bg-off'}`} data-testid={testId}>
      <div className="wrap">
        {eyebrow && <p className={`eyebrow mb-5 ${dark ? 'text-lilac' : ''}`}><Star className={dark ? 'text-lilac' : ''} />{eyebrow}</p>}
        <h1 className="display-2 max-w-[24ch] mb-4">{title}</h1>
        {intro && <p className={`text-lg max-w-[62ch] ${dark ? 'opacity-90' : 'text-ink/85'}`}>{intro}</p>}
        {children}
      </div>
    </section>
  );
};

export default PageIntro;
